import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, MapPin } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { areas } from '../mock';
import { Button } from './ui/button';

const SearchBar = () => {
  const { t } = useApp();
  const navigate = useNavigate();
  const [deal, setDeal] = useState('buy');
  const [ptype, setPtype] = useState('all');
  const [query, setQuery] = useState('');

  const tabs = [
    { key: 'buy', label: t('buy') },
    { key: 'rent', label: t('rent') },
    { key: 'offplan', label: t('nav_offplan') },
    { key: 'projects', label: t('projects') },
  ];

  const propertyTypes = ['Apartments', 'Villas', 'Townhouses', 'Commercial', 'Offices'];

  const popular = areas.slice(0, 8);

  const goSearch = (dealKey) => {
    setDeal(dealKey);
    const params = new URLSearchParams();
    const statusMap = { buy: '', rent: 'rent', offplan: 'offplan', projects: '' };
    const st = statusMap[dealKey];
    if (st) params.set('status', st);
    if (ptype && ptype !== 'all') params.set('type', ptype);
    if (query) params.set('q', query);
    navigate(`/projects?${params.toString()}`);
  };

  return (
    <section className="relative z-30 max-w-[1200px] mx-auto px-4 md:px-8 -mt-20">
      <div className="bg-white rounded-2xl shadow-[0_30px_60px_-25px_rgba(47,61,76,0.4)] p-4 md:p-6 fade-up">
        <h2 className="font-title text-lg md:text-2xl font-semibold text-gobra-slate mb-4">
          {t('search_title')}
        </h2>
        <div className="flex flex-wrap gap-1 mb-4">
          {tabs.map((tb) => (
            <button key={tb.key} type="button" onClick={() => goSearch(tb.key)} data-testid={`hero-tab-${tb.key}`}
              className={`px-4 md:px-5 py-2 rounded-full text-sm font-medium transition-colors ${deal === tb.key ? 'bg-gobra-green text-white' : 'bg-gobra-sand text-gobra-slate hover:bg-gobra-sand/70'}`}>
              {tb.label}
            </button>
          ))}
        </div>
        <div className="flex flex-col md:flex-row gap-3">
          <select value={ptype} onChange={(e) => setPtype(e.target.value)} data-testid="hero-type-select"
            className="bg-gobra-sand rounded-xl px-4 py-3 text-gobra-slate outline-none md:w-52 cursor-pointer">
            <option value="all">All Types</option>
            {propertyTypes.map((pt) => <option key={pt} value={pt}>{pt}</option>)}
          </select>
          <div className="flex-1 flex items-center gap-2 bg-gobra-sand rounded-xl px-4 py-3">
            <MapPin className="h-5 w-5 text-gobra-terracotta shrink-0" />
            <input value={query} onChange={(e) => setQuery(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && goSearch(deal)}
              placeholder={t('search_placeholder')}
              className="w-full bg-transparent outline-none text-gobra-slate placeholder:text-muted-foreground" />
          </div>
          <Button onClick={() => goSearch(deal)}
            className="bg-gobra-terracotta hover:bg-gobra-green text-white rounded-xl px-8 py-6 text-base">
            <Search className="h-5 w-5 mr-2" /> {t('search')}
          </Button>
        </div>
        <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2">
          <span className="text-xs text-muted-foreground font-medium">{t('popular_searches')}:</span>
          {popular.map((a) => (
            <button key={a} onClick={() => navigate(`/projects?q=${encodeURIComponent(a)}`)}
              className="text-xs text-gobra-blue hover:text-gobra-terracotta transition-colors">
              {a}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SearchBar;
